import type { FeedbackMessages } from './en';

const pl: FeedbackMessages = {
  qualified: {
    title: 'Dziękujemy za wzięcie udziału w tym badaniu!',
    body1: 'Mogą Państwo teraz zamknąć okno przeglądarki.',
    body2: 'Mamy nadzieję, że wkrótce znów się spotkamy.',
    refCode: 'Kod referencyjny: {code}',
  },
  quotaFull: {
    title: 'To badanie jest zamknięte',
    body1: 'Dziękujemy za zainteresowanie naszym badaniem.',
    body2: 'Niestety otrzymaliśmy już wszystkie potrzebne odpowiedzi.',
    body3: 'Mamy nadzieję, że będą Państwo mogli wziąć udział w jednym z naszych przyszłych badań!',
    refCode: 'Kod referencyjny: {code}',
  },
  terminated: {
    title: 'Dziękujemy za przekazanie opinii!',
    body1:
      'Mamy nadzieję, że wkrótce spotkamy się ponownie w ramach naszych przyszłych badań. Do tego czasu życzymy Państwu miłego dnia.',
    body2: 'Proszę zamknąć to okno przeglądarki.',
    refCode: 'Kod referencyjny: {code}',
  },
  mismatch: {
    title: 'Dziękujemy za zainteresowanie',
    body1: 'Niestety nie należą Państwo do grupy docelowej tego konkretnego badania.',
    body2: 'Mogą Państwo zamknąć tę stronę.',
    code: 'Kod: {code}',
  },
  error: {
    title: 'Nie możemy obsłużyć Państwa żądania',
    linkProblemDetailed:
      'Link, z którego Państwo skorzystali, ma problemy. Proszę sprawdzić, czy link w polu adresu zgadza się z tym, który Państwo otrzymali, i spróbować ponownie.',
    linkProblemGeneric:
      'Link, z którego Państwo skorzystali, ma problemy. Proszę spróbować ponownie.',
    contactPerson:
      'Jeśli problem będzie się powtarzał, prosimy poinformować o tym osobę, od której otrzymali Państwo ten link.',
    errorCode: 'Kod błędu: {code}',
  },
};

export default pl;
